export default "__VITE_ASSET__Cx8s$7ga__"